import { Grid } from '@mui/material'
import React from 'react'
import GlobalCard from '../../../../../../components/GlobalCardComponent'
import PaymentMethod from './PaymentMethod'
import OrderSummary from './OrderSummary'

export default function PaymentMethodAndProceed() {
  return (
    <GlobalCard height="100%"><Grid container spacing={2}>
    <Grid item xs={12}>
{/* Payment Method */}
<PaymentMethod/>
    </Grid>

    <Grid item xs={12}> 
        <OrderSummary/> </Grid>
   </Grid></GlobalCard>
   
  )
}
